import { render, staticRenderFns } from "./ReservationTicket.vue?vue&type=template&id=44db5388&"
import script from "./ReservationTicket.vue?vue&type=script&lang=js&"
export * from "./ReservationTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports